<script lang="ts">
import { useCtaComponent } from '@monogrid/vue-boost/core'
import { templateRef } from '@vueuse/core'
import gsap from 'gsap'
import { computed, defineComponent } from 'vue'

import LoadingSpinner from '@/components/atoms/LoadingSpinner.vue'

export default defineComponent({
  name: 'CtaPrimary',
  components: {
    LoadingSpinner
  },
  props: {
    green: { type: Boolean, default: false },
    filled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    scrambled: { type: Boolean, default: false },
    big: { type: Boolean, default: false }
  },
  setup (props, context) {
    const { bindings, component } = useCtaComponent(context)
    const elLabel = templateRef('elLabel')
    const text = computed(() => elLabel.value?.textContent)

    function onMouseEnter () {
      if (!props.scrambled) return

      gsap.to(elLabel.value, {
        scrambleText: {
          text: text.value,
          chars: text.value,
          tweenLength: true
        },
        duration: 1,
        ease: 'none'
      })
    }

    return {
      bindings,
      component,
      onMouseEnter
    }
  }
})
</script>

<template>
  <component
    :is="component"
    v-bind="bindings"
    class="cta-primary inline-flex items-center justify-center"
    :class="{ green, filled }"
    @mouseenter="onMouseEnter"
  >
    <span
      ref="elLabel"
      class="label1 whitespace-nowrap"
      :class="{
        'opacity-0': loading,
        big,
        'pointer-events-none': scrambled
      }"
    >
      <slot />
    </span>
    <Transition>
      <LoadingSpinner v-if="loading" centered />
    </Transition>
  </component>
</template>

<style lang="scss" scoped>
.cta-primary {
  min-height: rem(24px);
  padding: rem(4px 8px 5px 8px);
  border: 1px solid color('white');
  border-radius: rem(4px);
  background-color: transparent;
  color: color('white');
  text-decoration: none;
  transition: background-color var(--transition-duration), color var(--transition-duration);

  @include ensure-position;

  @include hover {
    &:hover {
      background-color: color('white');
      color: color('black');
    }
  }

  &.green {
    border-color: color('green');

    &.filled {
      background-color: color('green');
      color: color('black');
    }

    &:not(.filled) {
      color: color('green');

      @include hover {
        &:hover {
          background-color: color('green');
          color: color('black');
        }
      }
    }
  }

  &[disabled] {
    border-color: color('grey')!important;
    color: color('grey')!important;
    opacity: 0.5;
    pointer-events: none!important;
  }

  .label1 {
    line-height: 1;
    transition: opacity var(--transition-duration);

    &.big {
      font-size: rem(14px);
    }
  }
}
</style>
